<app-hero
title="Políticas de privacidad"
imageUrl="assets/images/privacy-policy/politicas-de-privacidad.svg"
[imageSettings]="{width: 662, height: 751}"></app-hero>

<app-info-block *ngFor="let policy of privacyPolicies"
    [titleBlock]="policy.title"
    [content]="policy.content"></app-info-block>
